// extracted by mini-css-extract-plugin
export default {"numberInput":"stake-unstake_numberInput__tlso7","numberInputHasError":"stake-unstake_numberInputHasError__OgB7s","buttonMax":"stake-unstake_buttonMax__ro4qP"};